// extracted by mini-css-extract-plugin
export default {"checkbox":"_1GU_f","align-items-center":"_201q4","alignItemsCenter":"_201q4","label-unset-font":"_3m93B","labelUnsetFont":"_3m93B"};